module.exports = __webpack_public_path__ + "img/consulta-vejez-anticipada.e6ee2cd5.png";